import { RegistrationStatus } from '@exam-center/graphql';
import { z } from 'zod';

export const ExamEventDetailsStatusSchema = z.object({
  status: z.nativeEnum(RegistrationStatus),
});

export type ExamEventDetailsStatusFormType = z.infer<typeof ExamEventDetailsStatusSchema>;
